import { useState, useEffect } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";
import { useNavigate } from "react-router-dom";
import MultiSelect from "./MultiSelect";

function ProductsUpdate() {
    const [musoniProducts, setMusoniProducts] =useState(null);
    const [picked, setPicked] = useState(null);
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosPrivate.get("/musoni_products", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setMusoniProducts(response.data);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };
        fetchData();
    }, [axiosPrivate, auth.accessToken]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosPrivate.get("/products", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setPicked(response.data.map(prod => prod.id));
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };
        fetchData();
    }, [axiosPrivate, auth.accessToken]);

    if (!musoniProducts || !picked) {
        return <div>Loading...</div>
    }

    const submit = async (e) => {
        e.preventDefault();
        const payload = musoniProducts.filter(prod => picked.includes(prod.id));
        try {
            await axiosPrivate.post('/products', payload, {headers: {Authorization: "Bearer " + auth.accessToken}});
            navigate("/products");
        } catch(err) {
            console.log(err);
        }
    }

    const ALLPRODUCTS = musoniProducts.map(product => ({ value: product.id, label: product.name}));

    return (
        <div className="mx-auto max-w-xl p-6">
            <h1 className="mb-4 text-2xl font-semibold">Select Products</h1>
            <p className="mb-3 text-sm text-gray-600">
                Click the field, type to filter, use ↑/↓ to move, Enter to toggle, Esc to close, and Backspace to remove the last chip.
            </p>
            <div className="mb-5">
                <MultiSelect options={ALLPRODUCTS} value={picked} onChange={setPicked} placeholder="Select some products" />
            </div>

            <button
                onClick={submit} 
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
                Submit
            </button>
        </div>
    )
}

export default ProductsUpdate;